import React, { useEffect, useState } from "react";
import BoardTable from "../../components/common/board/BoardTable";
import BoardPagination from "../../components/common/board/BoardPagination";
import BoardToolbar from "../../components/common/board/BoardToolbar";
import SearchBar from "../../components/common/board/SearchFilterBar"; // 공통 필터 컴포넌트로 변경
import { getWorkOrderList } from "../../api/const";
import { useParams, useNavigate } from "react-router-dom";
import PageHeader from "../../components/common/ui/PageHeader";

export default function WorkOrderBoard() {
  const { id: projectId } = useParams();
  const navigate = useNavigate();

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [total, setTotal] = useState(0);

  // 공통 검색/필터 형태로 수정
  const [q, setQ] = useState(""); // 검색어
  const [searchField, setSearchField] = useState("title"); // 검색 조건 필드
  const [dateFilter, setDateFilter] = useState("all");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [searchTrigger, setSearchTrigger] = useState(0);

  const getStatusBadge = (s) => {
    switch (s) {
      case "진행중": return "bg-yellow-100 text-yellow-800";
      case "완료보고서 등록됨": return "bg-green-100 text-green-800";
      default: return "bg-gray-100 text-gray-800";
    }
  };

  const columns = [
    { key: "title", header: "제목", width: 400, render: (row) => <div className="truncate max-w-[300px]">{row.title}</div> },
    { key: "created_at", header: "작성일", width: 160, render: (row) => row.created_at ? new Date(row.created_at).toLocaleDateString("ko-KR") : "-" },
    {
      key: "status", header: "상태", width: 120,
      render: (row) => {
        const label = row.completion?.length > 0 ? "완료보고서 등록됨" : "진행중";
        return <span className={`px-2 py-1 text-xs font-medium rounded-full border ${getStatusBadge(label)}`}>{label}</span>;
      }
    },
    { key: "created_by", header: "작성자", width: 120, render: (row) => row.created_by?.name || "-" },
    { key: "approval", header: "승인자", width: 120, render: (row) => row.approval?.approver_name || "-" },
  ];

  const fetchData = async () => {
    if (!projectId) return;
    setLoading(true);
    setError("");

    try {
      const params = {
        project: projectId,
        [searchField]: q, // 검색 필드 동적 적용
        start_date: startDate || undefined,
        end_date: endDate || undefined,
        page,
        page_size: pageSize,
      };

      const res = await getWorkOrderList(projectId, params);
      setRows(res.results ?? res);
      setTotal(res.count ?? res.total ?? res.length);
    } catch (e) {
      console.error(e);
      setError("작업지시서 데이터를 불러오지 못했습니다.");
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = () => {
    setPage(1); // 페이지 초기화
    setSearchTrigger((v) => v + 1);
  };

  useEffect(() => {
    if (projectId) fetchData();
  }, [projectId, page, pageSize, searchTrigger]);

  return (
    <div className="max-w-8xl mx-auto p-6 rounded-2xl bg-gray-50">
        <PageHeader>작업지시서 목록</PageHeader>
      <BoardToolbar
        right={
          <>
            <SearchBar
              q={q}
              onChangeQ={setQ}
              searchField={searchField}
              onChangeSearchField={setSearchField}
              dateFilter={dateFilter}
              onChangeDateFilter={setDateFilter}
              startDate={startDate}
              endDate={endDate}
              onDateChange={({ start, end }) => {
                setStartDate(start);
                setEndDate(end);
              }}
              onSearch={handleSearch}
              pageSize={pageSize}
              onChangePageSize={setPageSize}
            />
            <button
              className="btn-create"
              onClick={() => navigate(`new`)}
            >
              새 문서 등록
            </button>
          </>
        }
      />
      {/* 리스트 */}
      <BoardTable
        columns={columns}
        rows={rows}
        loading={loading}
        error={error}
        keyField="id"
        emptyText="작업지시서가 없습니다."
        onRowClick={(row) => navigate(`${row.dns}/view`)}
      />

      {/* 페이지네이션 */}
      <div className="mt-4">
        <BoardPagination page={page} pageSize={pageSize} total={total} onPageChange={setPage} />
      </div>
    </div>
  );
}

